
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/level01",
      function () {
        return require("private-next-pages/success-stories/level01/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/level01"])
      });
    }
  